import Toast from 'react-native-toast-message';

import { playSound } from '../../utils/sound';

// No topOffset: BroadcastToastHost's own one adds the safe-area inset, so the toast clears the
// status bar and camera cutout. One here would replace it.
const TOAST_BASE = {
	visibilityTime: 10_000,
	position: 'top' as const,
};

export function showGameBroadcastToast(
	type:
		| 'broadcastJackpot'
		| 'broadcastVegas'
		| 'broadcastTournament'
		| 'broadcastWhiskey'
		| 'rewardBonus'
		// Plain-text renderer, already registered in globalBroadcastToastConfig. Used
		// for messages that have no artwork of their own, such as being kicked.
		| 'error',
	text1: string,
	props?: Record<string, unknown>,
	text2?: string,
) {
	if (process.env.NODE_ENV !== 'production') {
		console.log('[GameBroadcast] Toast.show', { type, text1: text1.slice(0, 80) });
	}

	// v1 init.service plays ToastError on showPlayerKicked, the only 'error' user here.
	if (type === 'error') playSound('ToastError');

	Toast.show({
		...TOAST_BASE,
		type,
		text1,
		text2,
		props,
	});
}

const ACHIEVEMENT_TOAST_VISIBILITY_MS = 5_000;

export function showAchievementUnlockedToast(text1: string, displayTier: number, iconKey?: string) {
	Toast.show({
		...TOAST_BASE,
		visibilityTime: ACHIEVEMENT_TOAST_VISIBILITY_MS,
		type: 'achievementUnlocked',
		text1,
		props: { displayTier, iconKey },
	});
}

const PRIVATE_CHAT_TOAST_VISIBILITY_MS = 6_000;

/**
 * A private message, or a chat a donation just unlocked. Tapping it runs `onPress` (opening the
 * chat) and closes the toast.
 */
export function showPrivateChatToast(
	text1: string,
	text2: string | undefined,
	avatarFileId: string | null | undefined,
	onPress: () => void,
) {
	Toast.show({
		...TOAST_BASE,
		visibilityTime: PRIVATE_CHAT_TOAST_VISIBILITY_MS,
		type: 'privateChat',
		text1,
		text2,
		props: { avatarFileId: avatarFileId ?? null },
		onPress: () => {
			Toast.hide();
			onPress();
		},
	});
}
